import React, { useState, useEffect } from 'react';
import DashLayout from '../componets/layout/DashLayout';
import Preloader from '../componets/layout/preloader';
import './support.css';
import { supabase } from '../supabaseClient';

const Support = () => {
    const [selected, setSelected] = useState(null);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filterStatus, setFilterStatus] = useState('');
    const [search, setSearch] = useState('');

    useEffect(() => {
        const getData = async () => {
            const { data } = await supabase
                .from('supportmessages')
                .select('*, users(full_name, email)');
            setData(data);
            setLoading(false);
        };
        getData();
    }, []);

    const handleDelete = async (id) => {
        await supabase.from('supportmessages').delete().eq('id', id);
        setData(prev => prev.filter(item => item.id !== id));
        if (selected?.id === id) setSelected(null);
    };

    const filtered = data.filter(item => {
        const matchStatus = filterStatus === '' || item.status === filterStatus;
        const matchSearch = search === '' ||
            item.users?.full_name?.toLowerCase().includes(search.toLowerCase()) ||
            item.users?.email?.toLowerCase().includes(search.toLowerCase()) ||
            item.subject_en?.toLowerCase().includes(search.toLowerCase());
        return matchStatus && matchSearch;
    });

    return (
        <>
                    <Preloader />

            <DashLayout title="Support Messages" active="support">

                <div className="sp-top">
                    <h1 className="sp-title">Support Messages</h1>
                    <p className="sp-sub">Manage customer support inquiries and messages</p>
                </div>

                <div className="sp-stats">
                    <div className="sp-stat-card">
                        <div className="sp-stat-icon sp-stat-icon--total">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2 4a2 2 0 012-2h16a2 2 0 012 2v10a2 2 0 01-2 2H6l-4 4V4z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <div className="sp-stat-info">
                            <p className="sp-stat-label">Total Messages</p>
                            <p className="sp-stat-value">{data.length}</p>
                        </div>
                    </div>
                    <div className="sp-stat-card">
                        <div className="sp-stat-icon sp-stat-icon--new">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M12 7v5l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <div className="sp-stat-info">
                            <p className="sp-stat-label">New Messages</p>
                            <p className="sp-stat-value sp-stat-value--new">{data.filter(item => item.status === 'New').length}</p>
                        </div>
                    </div>
                    <div className="sp-stat-card">
                        <div className="sp-stat-icon sp-stat-icon--resolved">
                            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.5"/>
                                <path d="M8 12l3 3 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                        <div className="sp-stat-info">
                            <p className="sp-stat-label">Resolved</p>
                            <p className="sp-stat-value sp-stat-value--resolved">{data.filter(item => item.status === 'Resolved').length}</p>
                        </div>
                    </div>
                </div>

                <div className="sp-filters">
                    <div className="sp-search-wrap">
                        <svg className="sp-search-icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="9" cy="9" r="5.5" stroke="currentColor" strokeWidth="1.5"/>
                            <path d="M13 13l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                        </svg>
                        <input
                            type="text"
                            className="sp-search"
                            placeholder="Search messages..."
                            value={search}
                            onChange={e => setSearch(e.target.value)}
                        />
                    </div>
                    <select className="sp-select" value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                        <option value="">All Status</option>
                        <option value="New">New</option>
                        <option value="Resolved">Resolved</option>
                    </select>
                </div>

                <div className="sp-body">
                    <div className="sp-inbox">
                        <h3 className="sp-inbox-title">Inbox</h3>
                        <div className="sp-inbox-list">
                            {loading ? (
                                <p>Loading...</p>
                            ) : (
                                filtered.map((msg) => (
                                    <div
                                        key={msg.id}
                                        className={`sp-inbox-item ${selected?.id === msg.id ? 'sp-inbox-item--active' : ''}`}
                                        onClick={() => setSelected(msg)}
                                    >
                                        <div className="sp-inbox-item-top">
                                            <div className="sp-inbox-name-row">
                                                <p className="sp-inbox-name">{msg.users?.full_name}</p>
                                                <span className="sp-inbox-dot"></span>
                                            </div>
                                            <span className={`sp-badge sp-badge--${msg.status.toLowerCase()}`}>{msg.status}</span>
                                        </div>
                                        <p className="sp-inbox-email">{msg.users?.email}</p>
                                        <p className="sp-inbox-subject">{msg.subject_en}</p>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>

                    <div className="sp-detail">
                        {selected ? (
                            <>
                                <div className="sp-detail-header">
                                    <h3 className="sp-detail-title">Message Details</h3>
                                    <svg className="sp-detail-close" onClick={() => setSelected(null)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                                    </svg>
                                </div>
                                <div className="sp-detail-body">
                                    <span className={`sp-badge sp-badge--${selected.status.toLowerCase()}`}>{selected.status}</span>
                                    <div className="sp-detail-meta">
                                        <div className="sp-detail-meta-row">
                                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="10" cy="7" r="3.5" stroke="currentColor" strokeWidth="1.5"/>
                                                <path d="M3 17c0-3.866 3.134-7 7-7s7 3.134 7 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                            </svg>
                                            <span>{selected.users?.full_name}</span>
                                        </div>
                                        <div className="sp-detail-meta-row">
                                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="2" y="4" width="16" height="12" rx="2" stroke="currentColor" strokeWidth="1.5"/>
                                                <path d="M2 7l8 5 8-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                                            </svg>
                                            <span>{selected.users?.email}</span>
                                        </div>
                                    </div>
                                    <div className="sp-detail-section">
                                        <p className="sp-detail-section-label">Subject</p>
                                        <p className="sp-detail-subject">{selected.subject_en}</p>
                                    </div>
                                    <div className="sp-detail-section">
                                        <p className="sp-detail-section-label">Message</p>
                                        <div className="sp-detail-message">{selected.message_en}</div>
                                    </div>
                                    <div className="sp-detail-actions">
                                        <button className="sp-resolve-btn">
                                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <circle cx="10" cy="10" r="7.5" stroke="currentColor" strokeWidth="1.5"/>
                                                <path d="M6.5 10l2.5 2.5 4.5-4.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                            Mark as Resolved
                                        </button>
                                        <button className="sp-del-btn" onClick={() => handleDelete(selected.id)}>
                                            <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M3 5h14M8 5V3h4v2M6 5l1 11h6l1-11" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="sp-detail-empty">
                                <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4 8a4 4 0 014-4h32a4 4 0 014 4v20a4 4 0 01-4 4H12l-8 8V8z" stroke="currentColor" strokeWidth="2" strokeLinejoin="round"/>
                                </svg>
                                <p>Select a message to view details</p>
                            </div>
                        )}
                    </div>
                </div>

            </DashLayout>
        </>
    );
};

export default Support;